module.exports = __webpack_public_path__ + "img/comment-quote.fc48cd2d.svg";